import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User is logged out due to inactivity',
  name: 'logged_out_user_due_to_inactivity',
};

export default META;
